import React from 'react';
const Profile = (props: React.SVGProps<SVGSVGElement>) =>
(
	<svg viewBox="0 0 46 46"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<path d="M43.418,2.271c-1.494-1.363-3.48-2.175-5.663-2.175H8.404c-4.575,0-8.295,3.636-8.401,8.185C0.002,8.361,0,8.421,0,8.5
		v29.201c0,4.641,3.762,8.404,8.404,8.404h29.394c4.644,0,8.404-3.764,8.404-8.404V8.5C46.202,6.02,45.126,3.81,43.418,2.271z
		 M30.854,14.852c0,4.33-3.51,7.839-7.838,7.839c-4.327,0-7.837-3.509-7.837-7.839c0-4.328,3.51-7.838,7.837-7.838
		C27.346,7.013,30.854,10.523,30.854,14.852z M14.112,40.087c-2.005,0-3.63-1.625-3.63-3.63v-2.047c0-4.387,3.585-7.912,7.971-7.912
		h9.127c4.387,0,7.943,3.523,7.943,7.912v2.047c0,2.005-1.625,3.63-3.629,3.63H14.112z"
			fill="currentColor" />

	</svg>
);
export default Profile;